import { Component, Input } from '@angular/core';
import { BaseForm } from '@app/modules/forms/base.form';
import { TimeOffTransaction } from '@app/models/time-off-v3/time-off-transaction.model';
import moment from 'moment';
import { TimeOffDateFormatDashes } from '../../meta/time-off-meta';
import { TimeOffType } from '@models/time-off-v3/time-off-type.model';
import { TimeOffService } from '@time-off-v3/services';
import { Translatable } from '@app/types/translatable.type';

type Operation = 'add' | 'subtract';

@Component({
    selector: 'app-adjustment-form',
    templateUrl: 'adjustment.template.html',
    styleUrls: ['adjustment.style.scss'],
})
export class AdjustmentForm extends BaseForm {
    @Input() timeOffTypes: TimeOffType[] = [];
    @Input() employeeId: number;
    timeOffTransaction: TimeOffTransaction = new TimeOffTransaction({
        processedAt: moment().format(TimeOffDateFormatDashes),
        isBalanceReset: false,
    });
    addOrSubtract: Operation = 'add';
    balance = 0;
    amount = 0;
    balanceAfter = 0;

    constructor(private timeOffService: TimeOffService) {
        super();
    }

    get unitOfTime(): Translatable {
        return this.timeOffType?.unitOfTimePlural
            ? `time-off-v3.${this.timeOffType?.unitOfTimePlural}`.toString()
            : this.timeOffType?.unitOfTimePlural;
    }

    get timeOffType(): TimeOffType {
        return this.timeOffTypes?.find((timeOffType) => timeOffType.id === this.timeOffTransaction.timeOffTypeId);
    }

    beforeShow(): void {
        this.getBalance();
    }

    setAmount(amount: number): void {
        if (amount) {
            this.amount = amount;
            this.timeOffTransaction.amount = this.addOrSubtract === 'add' ? amount : -amount;
        }
    }

    operationChange(operation: Operation): void {
        if (this.amount) {
            this.timeOffTransaction.amount = operation === 'add' ? this.amount : -this.amount;
        }
    }

    calculateBalanceAfter(): void {
        this.balanceAfter = this.addOrSubtract === 'add' ? this.balance + this.amount : this.balance - this.amount;
    }

    getBalance(): void {
        this.timeOffService
            .getBalance(this.employeeId, {
                'filters[timeOffTypeId]': this.timeOffType.id,
                'filters[processedAt][to]': moment(this.timeOffTransaction.processedAt).format(TimeOffDateFormatDashes),
            })
            .then(
                (timeOffBalance) =>
                    (this.balance = this.timeOffType.displayInHours
                        ? timeOffBalance.balanceHours
                        : timeOffBalance.balance)
            )
            .then(() => this.calculateBalanceAfter());
    }
}
